<template>
  <v-row>
    <v-dialog v-model="showDialog" scrollable max-width="750px">
      <v-card>
        <v-card-title style="padding: 5px 0 0 5px;">
          <v-col cols="12">
						<span style="font-size: 20px;">
							{{ !data.id ? $t('wkt.admin.report-types.edit-report-type.edit-title-new') : $t('wkt.admin.report-types.edit-report-type.edit-title-edit') }}
						</span>
            <!--<v-btn icon style="top: -20px; left: 10px; float: right;">
              <v-icon @click="showDialog=false">close</v-icon>
            </v-btn>-->
          </v-col>
        </v-card-title>
				<v-divider></v-divider>
        <v-card-text style="padding-bottom: 0;">
          <v-container>
						<v-form ref="form">
							<v-row style="margin-top: 10px;">
								<v-col cols="12">
									<v-autocomplete
										v-model="data.companyId"
										:items="companies"
										item-text="name"
										item-value="id"
										menu-props="bottom, offsetY"
										:label="$t('wkt.admin.report-types.edit-report-type.company')"
									/>
								</v-col>

								<v-col cols="12">                
									<v-text-field
										v-model="data.title"
										:label="$t('wkt.admin.report-types.edit-report-type.title')"
										autocomplete="none"
										:rules="[validationRules.required]"
										max="200"
									/>
								</v-col>

								<v-col cols="12">
									<v-select
										chips
										multiple
										v-model="rolesAllowed"
										:items="roles"
										item-text="name"
										item-value="id"
										menu-props="bottom, offsetY"
										:label="$t('wkt.admin.report-types.edit-report-type.roles_allowed')"
									/>
								</v-col>

								<v-col cols="12">
									<v-select
										chips
										multiple
										v-model="fields"
										:items="filters"
										item-text="name"
										item-value="id"
										menu-props="bottom, offsetY"
										:label="$t('wkt.admin.report-types.edit-report-type.fields')"
									/>
								</v-col>

								<v-col cols="12">                
									<v-text-field
										v-model="data.report"
										:label="$t('wkt.admin.report-types.edit-report-type.report')"
										autocomplete="none"
										:rules="[validationRules.required]"
										max="200"
									/>
								</v-col>

								<v-col cols="12" v-if="data.type==2">                
									<v-text-field
										v-model="data.clauses"
										label="Clauses"
										autocomplete="none"
										max="200"
									/>
								</v-col>
								<v-col cols="12" v-if="data.type==2">                 
									<v-text-field
										v-model="data.clientConfig"
										label="Client config"
										autocomplete="none"
										max="200"
									/>
								</v-col>
														
								<v-col cols="12" sm="6" md="5">
									<span>{{ $t('wkt.admin.report-types.edit-report-type.type') }}</span>
									<v-radio-group v-model="data.type" row style="position: relative; top: -15px; max-height: 94px;">
										<v-radio label="JASPER" :value="0"/>
										<v-radio label="WEBHOOK" :value="1"/>
										<v-radio label="SUPERSET" :value="2"/>
									</v-radio-group>
								</v-col>
														
								<v-col cols="12" sm="6" md="4">
									<span>{{ $t('wkt.admin.report-types.edit-report-type.module') }}</span>
									<v-radio-group v-model="data.module" row style="position: relative; top: -15px; max-height: 94px;"
										:rules="[validationRules.requiredBoolean]">
										<v-radio label="ADMIN" :value="'ADMIN'"/>
										<v-radio label="CLIENT" :value="'CLIENT'"/>
									</v-radio-group>
								</v-col>
														
								<v-col cols="12" sm="6" md="3">
									<span>{{ $t('wkt.admin.report-types.edit-report-type.enabled') }}</span>
									<v-radio-group v-model="data.enabled" row style="position: relative; top: -15px; max-height: 94px;"
										:rules="[validationRules.requiredBoolean]">
										<v-radio :label="$t('wkt.admin.common.yes')" :value="true"/>
										<v-radio :label="$t('wkt.admin.common.no')" :value="false"/>
									</v-radio-group>
								</v-col>
							</v-row>
						</v-form>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn v-if="showDeleteButton" color="#ff0000" @click="confirmDelete()">
						<v-icon left color="#ffffff">delete</v-icon>
						<span style="color: #ffffff;">{{ $t('wkt.admin.common.dialog-buttons.delete').toUpperCase() }}</span>
					</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="#185EA9" text @click="ok()" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.ok').toUpperCase() }}</v-btn>
          <v-btn text @click="showDialog=false" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.cancel').toUpperCase() }}</v-btn>
        </v-card-actions>
      </v-card>
			<LoadingDialog :loading="loading" />
    </v-dialog>

		<ConfirmDialog ref="dlgConfirm"
			v-bind:title="$t('wkt.admin.report-types.edit-report-type.confirm-dialog.title')"
			v-bind:message="$t('wkt.admin.report-types.edit-report-type.confirm-dialog.text')"
			v-bind:titleOk="$t('wkt.admin.common.dialog-buttons.delete')"
			v-bind:titleCancel="$t('wkt.admin.common.dialog-buttons.cancel')"
			v-on:confirmed="deleteItem()"
		/>
  </v-row>	
</template>

<script>
import BaseModule from '../common/BaseModule.js'
import ConfirmDialog from '../common/ConfirmDialog'
import LoadingDialog from '../common/LoadingDialog'
import api from '../../api/worktime'
import gwt from '../../api/gwt'

  export default {
    name: 'ReportTypeDialog',
    mixins: [BaseModule],
		components: {
			ConfirmDialog, LoadingDialog
		},
    data () {
      return {
				loading: false,
        showDialog: false,
				roles: [],
				rolesAllowed: [],
				filters: [
					{ id: 'month', name: 'Filtro \'Mes\' obligatorio' },
					{ id: 'month?', name: 'Filtro \'Mes\' opcional' },
					{ id: 'year', name: 'Filtro \'Año\' obligatorio' },
					{ id: 'year?', name: 'Filtro \'Año\' opcional' },
					{ id: 'start_date', name: 'Filtro \'Fecha inicio\' obligatorio' },
					{ id: 'start_date?', name: 'Filtro \'Fecha inicio\' opcional' },
					{ id: 'end_date', name: 'Filtro \'Fecha fin\' obligatorio' },
					{ id: 'end_date?', name: 'Filtro \'Fecha fin\' opcional' },
					{ id: 'workplace_id', name: 'Filtro \'Centro de trabajo\' obligatorio' },
					{ id: 'workplace_id?', name: 'Filtro \'Centro de trabajo\' opcional' },
					{ id: 'department_id', name: 'Filtro \'Departamento\' obligatorio' },
					{ id: 'department_id?', name: 'Filtro \'Departamento\' opcional' },
					{ id: 'project_id', name: 'Filtro \'Proyecto\' obligatorio' },
					{ id: 'project_id?', name: 'Filtro \'Proyecto\' opcional' },
					{ id: 'employee_id', name: 'Filtro \'Trabajador\' obligatorio' },
					{ id: 'employee_id?', name: 'Filtro \'Trabajador\' opcional' },
				],
				fields: [],
        companies: [],
        data: {},
        msgCb: null,
				showDeleteButton: false
      }
    },
    methods: {
			buildEmptyData() {
				var data = {
					id: null,
					companyId: null,
					title: null,
					module: null,
					rolesAllowed: null,
					fields: null,
					report: null,
					type: null,
					enabled: true,
				};

				return data;
			},
      open: function(companies, data, msgCb) {
				if (this.$refs.form) {
					this.$refs.form.resetValidation();
				}

				this.clear();

				this.companies = companies;
        this.data = data;

				this.fillRoles();
				
				if (this.data) {
					if (this.data.rolesAllowed && this.data.rolesAllowed.length > 0) {
						this.rolesAllowed = this.data.rolesAllowed.split(',');
					}
					if (this.data.fields && this.data.fields.length > 0) {
						this.fields = this.data.fields.split(',');
					}
				} else {
					this.data = this.buildEmptyData();
				}

        this.msgCb = msgCb;
				this.showDeleteButton = data != null;
        this.showDialog = true;
      },
			clear() {				
				this.roles = [];
				this.rolesAllowed = [];
				this.fields = [];
        this.companies = [];

				this.data = this.buildEmptyData();
			},
			fillRoles() {
				var profile = gwt.getSessionProfile();

				this.roles = [];

				if (profile.moduleMessages != 0) {
					this.roles.push({ id: 'messages', name: 'Módulo \'Comunicación interna\'' });
				}
				if (profile.moduleNews != 0) {
					this.roles.push({ id: 'news', name: 'Módulo \'Actualidad\'' });
				}
				if (profile.moduleDaily != 0) {
					this.roles.push({ id: 'daily', name: 'Módulo \'Check-in diario\'' });
				}
				if (profile.moduleMonthly != 0) {
					this.roles.push({ id: 'monthly', name: 'Módulo \'Check-in mensual\'' });
				}
				if (profile.moduleEmployee != 0) {
					this.roles.push({ id: 'employee', name: 'Módulo \'Check-in trabajador\'' });
				}
				if (profile.moduleProcedures != 0) {
					this.roles.push({ id: 'procedures', name: 'Módulo \'Solicitudes\'' });
				}
				if (profile.moduleDocuments != 0) {
					this.roles.push({ id: 'documents', name: 'Módulo \'Explorar documentos\'' });
				}
				if (profile.modulePDocuments != 0) {
					this.roles.push({ id: 'pdocuments', name: 'Módulo \'Buscar documentos\'' });
				}
				if (profile.moduleHCalendar != 0) {
					this.roles.push({ id: 'hcalendar', name: 'Módulo \'Calendario de vacaciones\'' });
				}if (profile.moduleAI != 0) {
					this.roles.push({ id: 'ai', name: 'Módulo \'AI\'' });
				}
				if (profile.moduleHolidays != 0) {
					this.roles.push({ id: 'holidays', name: 'Módulo \'Registro de vacaciones\'' });
				}
				if (profile.moduleStaff != 0) {
					this.roles.push({ id: 'staff', name: 'Módulo \'Plantilla\'' });
				}
				if (profile.moduleProjects != 0) {
					this.roles.push({ id: 'projects', name: 'Módulo \'Proyectos\'' });
				}
				if (profile.modulePlanning != 0) {
					this.roles.push({ id: 'planning', name: 'Módulo \'Calendario de planificación\'' });
				}
				if (profile.moduleWorkplace != 0) {
					this.roles.push({ id: 'workplace', name: 'Módulo \'Centros de trabajo\'' });
				}
				if (profile.moduleDepartments != 0) {
					this.roles.push({ id: 'departments', name: 'Módulo \'Departamentos\'' });
				}
				if (profile.moduleCalendar != 0) {
					this.roles.push({ id: 'calendar', name: 'Módulo \'Calendarios\'' });
				}
				if (profile.moduleVPolicy != 0) {
					this.roles.push({ id: 'vpolicy', name: 'Módulo \'Políticas de vacaciones\'' });
				}
				if (profile.modulePDefinition != 0) {
					this.roles.push({ id: 'pdefinition', name: 'Módulo \'Tipos de solicitud\'' });
				}
				if (profile.moduleActivityType != 0) {
					this.roles.push({ id: 'activityType', name: 'Módulo \'Tipos de actividad\'' });
				}
				if (profile.moduleDocumentCategory != 0) {
					this.roles.push({ id: 'documentCategory', name: 'Módulo \'Categorías de documento\'' });
				}
				if (profile.moduleChatConfig != 0) {
					this.roles.push({ id: 'chatconfig', name: 'Módulo \'Canales de colaboración\'' });
				}
				if (profile.moduleIntegration != 0) {
					this.roles.push({ id: 'integration', name: 'Módulo \'Integración\'' });
				}
				if (profile.moduleLicense != 0) {
					this.roles.push({ id: 'license', name: 'Módulo \'Licencia\'' });
				}
				if (profile.moduleLicense != 0) {
					this.roles.push({ id: 'private', name: 'Ninguno: Acceso bloqueado' });
				}
			},
      ok: function() {
				if (!this.$refs.form.validate()) {
					return;
				}

        if (this.rolesAllowed.length > 0) {
					this.data.rolesAllowed = this.rolesAllowed.join();
				} else {
					this.data.rolesAllowed = null;
				}

        if (this.fields.length > 0) {
					this.data.fields = this.fields.join();
				} else {
					this.data.fields = null;
				}

				this.loading = true;

				api.storeReportType(this.data,
					res => {
						this.loading = false;
						this.showDialog = false;
            if (this.msgCb) {
							this.msgCb(res.message, res.rsOK);
						}
					},
					error => {
						this.loading = false;
						this.$log.error(error);
						if (this.msgCb) {
              this.msgCb(error.message, false);
						}
					});
      },
			confirmDelete() {
				this.$refs.dlgConfirm.confirm(this.data);
			},
			deleteItem() {	
				this.loading = true;

				api.deleteReportTypeById(this.data.id,
					res => {
						this.loading = false;
						this.showDialog = false;
            if (this.msgCb) {
							this.msgCb(res.message, res.rsOK);
						}
					},
					(error) => {
						this.loading = false;
						this.$log.error(error);
						if (this.msgCb) {
              this.msgCb(error.message, false);
						}
					}
				);
			}
    },
  }
</script>